import { TabList } from '@mui/lab'

export const OvTabList = ({ children, variant = 'scrollable', ...rest }: any) => {
  return (
    <TabList
      allowScrollButtonsMobile
      {...rest}
      variant={variant}>
      {children}
    </TabList>
  )
}
